import React from 'react';

const ProfileButton = ({ onClick }) => {
  return (
    <button className="profile-btn" onClick={onClick} aria-label="Profile">
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="16" cy="16" r="16" fill="#fff"/>
        <circle cx="16" cy="13" r="5" fill="#e74c3c"/>
        <ellipse cx="16" cy="23" rx="7" ry="4" fill="#e74c3c"/>
      </svg>
    </button>
  );
};

export default ProfileButton;